import React, { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmtErr = (detail) => {
  if (!detail) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ") || "Invalid input";
  return String(detail.msg || detail);
};

export default function LockScreen({ onAuthed }) {
  const [mode, setMode] = useState("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const switchMode = (m) => {
    setMode(m);
    setError("");
  };

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (mode === "register") {
      if (!name.trim()) {
        setError("Your full name is required — it signs your records");
        return;
      }
      if (password !== confirm) {
        setError("Passwords do not match");
        return;
      }
    }
    setBusy(true);
    try {
      const url = mode === "login" ? `${API}/auth/login` : `${API}/auth/register`;
      const body = mode === "login" ? { email, password } : { name, email, password };
      const res = await axios.post(url, body);
      onAuthed(res.data.token, res.data.user);
    } catch (err) {
      setError(fmtErr(err.response?.data?.detail) || "Could not sign in");
    }
    setBusy(false);
  };

  return (
    <div className="lock-screen" data-testid="lock-screen">
      <form className="lock-card" onSubmit={submit}>
        <div className="lock-brand">ECH <span>/ Operations, Compliance &amp; SOP Manual</span></div>
        <div className="lock-conf">CONFIDENTIAL — INTERNAL</div>
        <div className="lock-tabs">
          <button type="button" className={`lock-tab${mode === "login" ? " active" : ""}`} onClick={() => switchMode("login")} data-testid="lock-mode-login">Sign in</button>
          <button type="button" className={`lock-tab${mode === "register" ? " active" : ""}`} onClick={() => switchMode("register")} data-testid="lock-mode-register">Create account</button>
        </div>
        <p className="lock-sub">{mode === "login"
          ? "This system holds attestations, signed records, and the compliance registers. Sign in with your personal account — every record you sign is tied to your identity."
          : "Create your team-member account. Your name and email are stamped on every attestation and record you sign (ECH-SOP-1.1)."}</p>
        {mode === "register" && (
          <input className="lock-input" type="text" placeholder="Full name (as it should appear on records)" value={name}
            onChange={(e) => setName(e.target.value)} data-testid="lock-name" />
        )}
        <input className="lock-input" type="email" placeholder="Work email" value={email}
          onChange={(e) => setEmail(e.target.value)} autoFocus data-testid="lock-email" />
        <input className="lock-input" type="password" placeholder="Password" value={password}
          onChange={(e) => setPassword(e.target.value)} data-testid="lock-password" />
        {mode === "register" && (
          <input className="lock-input" type="password" placeholder="Confirm password" value={confirm}
            onChange={(e) => setConfirm(e.target.value)} data-testid="lock-confirm" />
        )}
        {error && <div className="lock-error" data-testid="lock-error">{error}</div>}
        <button className="lock-btn" type="submit" disabled={busy || password.length < 6 || !email} data-testid="lock-submit">
          {mode === "login" ? "Sign in" : "Create account & enter"}
        </button>
        <div className="lock-note">Minimum 6 characters. Your account signs your attestations — do not share it.</div>
      </form>
    </div>
  );
}
